import type { HapticFeedbackTypes, HapticOptions } from 'react-native-haptic-feedback';

export const triggerHaptics = async (
  type?: keyof typeof HapticFeedbackTypes,
  options?: HapticOptions
) => {};
